var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var graphQlTokenMap = require('./tokens').graphQlTokenMap;
import { Parser, Lexer, } from 'chevrotain';
var BaseGraphQlParser = /** @class */ (function (_super) {
    __extends(BaseGraphQlParser, _super);
    function BaseGraphQlParser(options, tokenVocab) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, tokenVocab, __assign({ recoveryEnabled: true, outputCst: true }, options.config)) || this;
        _this.tokenize = function (document) {
            return _this.lexer.tokenize(document).tokens;
        };
        _this.parse = function (document, entryRule) {
            if (entryRule === void 0) { entryRule = _this.Document; }
            _this.input = _this.lexer.tokenize(document).tokens;
            var cst = entryRule.call(_this);
            var errors = _this.errors;
            return {
                errors: errors,
                cst: cst,
            };
        };
        _this.Document = _this.RULE('Document', function () {
            _this.AT_LEAST_ONE(function () { return _this.SUBRULE(_this.Definition); });
        });
        _this.Definition = _this.RULE('Definition', function () {
            _this.OR([
                { ALT: function () { return _this.SUBRULE(_this.ExecutableDefinition); } },
                { ALT: function () { return _this.SUBRULE(_this.TypeSystemDefinition); } },
                { ALT: function () { return _this.SUBRULE(_this.TypeSystemExtension); } },
            ]);
        });
        _this.ExecutableDefinition = _this.RULE('ExecutableDefinition', function () {
            _this.OR([
                { ALT: function () { return _this.SUBRULE(_this.OperationDefinition); } },
                { ALT: function () { return _this.SUBRULE(_this.FragmentDefinition); } },
            ]);
        });
        _this.OperationDefinition = _this.RULE('OperationDefinition', function () {
            _this.OR([
                { ALT: function () { return _this.SUBRULE(_this.SelectionSet); } },
                {
                    ALT: function () {
                        _this.SUBRULE(_this.OperationType);
                        _this.OPTION(function () { return _this.CONSUME(graphQlTokenMap.Name); });
                        _this.OPTION1(function () { return _this.SUBRULE(_this.VariableDefinitions); });
                        _this.OPTION2(function () { return _this.SUBRULE(_this.Directives); });
                        _this.SUBRULE1(_this.SelectionSet);
                    },
                },
            ]);
        });
        _this.OperationType = _this.RULE('OperationType', function () {
            _this.OR([
                { ALT: function () { return _this.CONSUME(graphQlTokenMap.Query); } },
                { ALT: function () { return _this.CONSUME(graphQlTokenMap.Mutation); } },
                { ALT: function () { return _this.CONSUME(graphQlTokenMap.Subscription); } },
            ]);
        });
        _this.SelectionSet = _this.RULE('SelectionSet', function () {
            _this.CONSUME(graphQlTokenMap.LCurly);
            _this.AT_LEAST_ONE(function () { return _this.SUBRULE(_this.Selection); });
            _this.CONSUME(graphQlTokenMap.RCurly);
        });
        _this.Selection = _this.RULE('Selection', function () {
            _this.OR([
                { ALT: function () { return _this.SUBRULE(_this.Field); } },
                { ALT: function () { return _this.SUBRULE(_this.InlineFragment); } },
                { ALT: function () { return _this.SUBRULE(_this.FragmentSpread); } },
            ]);
        });
        _this.Field = _this.RULE('Field', function () {
            _this.OPTION(function () { return _this.SUBRULE(_this.Alias); });
            _this.CONSUME(graphQlTokenMap.Name);
            _this.OPTION1(function () {
                return _this.SUBRULE(_this.Arguments, { ARGS: [false /* isConst */] });
            });
            _this.OPTION2(function () { return _this.SUBRULE(_this.Directives); });
            _this.OPTION3(function () { return _this.SUBRULE(_this.SelectionSet); });
        });
        _this.Alias = _this.RULE('Alias', function () {
            _this.CONSUME(graphQlTokenMap.Name);
            _this.CONSUME(graphQlTokenMap.Colon);
        });
        _this.Arguments = _this.RULE('Arguments', function (isConst) {
            _this.CONSUME(graphQlTokenMap.LParen);
            _this.AT_LEAST_ONE(function () { return _this.SUBRULE(_this.Argument, { ARGS: [isConst] }); });
            _this.CONSUME(graphQlTokenMap.RParen);
        });
        _this.Argument = _this.RULE('Argument', function (isConst) {
            _this.SUBRULE(_this.Alias);
            _this.SUBRULE(_this.Value, { ARGS: [isConst] });
        });
        _this.FragmentSpread = _this.RULE('FragmentSpread', function () {
            _this.CONSUME(graphQlTokenMap.Spread);
            _this.CONSUME(graphQlTokenMap.FragmentName);
            _this.OPTION(function () { return _this.SUBRULE(_this.Directives); });
        });
        _this.InlineFragment = _this.RULE('InlineFragment', function () {
            _this.CONSUME(graphQlTokenMap.Spread);
            _this.OPTION(function () { return _this.SUBRULE(_this.TypeCondition); });
            _this.OPTION1(function () { return _this.SUBRULE(_this.Directives); });
            _this.SUBRULE(_this.SelectionSet);
        });
        _this.FragmentDefinition = _this.RULE('FragmentDefinition', function () {
            _this.CONSUME(graphQlTokenMap.Fragment);
            _this.CONSUME(graphQlTokenMap.FragmentName);
            _this.SUBRULE(_this.TypeCondition);
            _this.OPTION(function () { return _this.SUBRULE(_this.Directives); });
            _this.SUBRULE(_this.SelectionSet);
        });
        _this.TypeCondition = _this.RULE('TypeCondition', function () {
            _this.CONSUME(graphQlTokenMap.On);
            _this.SUBRULE(_this.NamedType);
        });
        _this.Value = _this.RULE('Value', function (isConst) {
            _this.OR([
                { GATE: function () { return !isConst; }, ALT: function () { return _this.SUBRULE(_this.Variable); } },
                { ALT: function () { return _this.SUBRULE(_this.IntValue); } },
                { ALT: function () { return _this.SUBRULE(_this.FloatValue); } },
                { ALT: function () { return _this.SUBRULE(_this.StringValue); } },
                { ALT: function () { return _this.SUBRULE(_this.BooleanValue); } },
                { ALT: function () { return _this.SUBRULE(_this.NullValue); } },
                { ALT: function () { return _this.SUBRULE(_this.EnumValue); } },
                { ALT: function () { return _this.SUBRULE(_this.ListValue, { ARGS: [isConst] }); } },
                { ALT: function () { return _this.SUBRULE(_this.ObjectValue, { ARGS: [isConst] }); } },
            ]);
        });
        _this.IntValue = _this.RULE('IntValue', function () {
            _this.CONSUME(graphQlTokenMap.IntValueToken);
        });
        _this.FloatValue = _this.RULE('FloatValue', function () {
            _this.CONSUME(graphQlTokenMap.FloatValueToken);
        });
        _this.StringValue = _this.RULE('StringValue', function () {
            _this.CONSUME(graphQlTokenMap.StringValueToken);
        });
        _this.BooleanValue = _this.RULE('BooleanValue', function () {
            _this.CONSUME(graphQlTokenMap.BooleanValueToken);
        });
        _this.NullValue = _this.RULE('NullValue', function () {
            _this.CONSUME(graphQlTokenMap.NullValueToken);
        });
        _this.EnumValue = _this.RULE('EnumValue', function () {
            _this.CONSUME(graphQlTokenMap.EnumValueToken);
        });
        _this.ListValue = _this.RULE('ListValue', function (isConst) {
            _this.CONSUME(graphQlTokenMap.LBracket);
            _this.MANY(function () { return _this.SUBRULE(_this.Value, { ARGS: [isConst] }); });
            _this.CONSUME(graphQlTokenMap.RBracket);
        });
        _this.ObjectValue = _this.RULE('ObjectValue', function (isConst) {
            _this.CONSUME(graphQlTokenMap.LCurly);
            _this.MANY(function () { return _this.SUBRULE(_this.ObjectField, { ARGS: [isConst] }); });
            _this.CONSUME(graphQlTokenMap.RCurly);
        });
        _this.ObjectField = _this.RULE('ObjectField', function (isConst) {
            _this.SUBRULE(_this.Alias);
            _this.SUBRULE(_this.Value, { ARGS: [isConst] });
        });
        _this.VariableDefinitions = _this.RULE('VariableDefinitions', function () {
            _this.CONSUME(graphQlTokenMap.LParen);
            _this.AT_LEAST_ONE(function () { return _this.SUBRULE(_this.VariableDefinition); });
            _this.CONSUME(graphQlTokenMap.RParen);
        });
        _this.VariableDefinition = _this.RULE('VariableDefinition', function () {
            _this.SUBRULE(_this.Variable);
            _this.CONSUME(graphQlTokenMap.Colon);
            _this.SUBRULE(_this.Type);
            _this.OPTION(function () { return _this.SUBRULE(_this.DefaultValue); });
        });
        _this.Variable = _this.RULE('Variable', function () {
            _this.CONSUME(graphQlTokenMap.Dollar);
            _this.CONSUME(graphQlTokenMap.Name);
        });
        _this.DefaultValue = _this.RULE('DefaultValue', function () {
            _this.CONSUME(graphQlTokenMap.Equals);
            _this.SUBRULE(_this.Value, { ARGS: [true /* isConst */] });
        });
        _this.Type = _this.RULE('Type', function () {
            _this.OR([
                { ALT: function () { return _this.SUBRULE(_this.NamedType); } },
                { ALT: function () { return _this.SUBRULE(_this.ListType); } },
            ]);
            _this.OPTION(function () { return _this.CONSUME(graphQlTokenMap.Bang); });
        });
        _this.NamedType = _this.RULE('NamedType', function () {
            _this.CONSUME(graphQlTokenMap.Name);
        });
        _this.ListType = _this.RULE('ListType', function () {
            _this.CONSUME(graphQlTokenMap.LBracket);
            _this.SUBRULE(_this.Type);
            _this.CONSUME(graphQlTokenMap.RBracket);
        });
        _this.Directives = _this.RULE('Directives', function (isConst) {
            _this.AT_LEAST_ONE(function () { return _this.SUBRULE(_this.Directive, { ARGS: [isConst] }); });
        });
        _this.Directive = _this.RULE('Directive', function (isConst) {
            _this.CONSUME(graphQlTokenMap.At);
            _this.CONSUME(graphQlTokenMap.Name);
            _this.OPTION(function () { return _this.SUBRULE(_this.Arguments, { ARGS: [isConst] }); });
        });
        _this.TypeSystemDefinition = _this.RULE('TypeSystemDefinition', function () {
            _this.OR([
                { ALT: function () { return _this.SUBRULE(_this.SchemaDefinition); } },
                { ALT: function () { return _this.SUBRULE(_this.TypeDefinition); } },
                { ALT: function () { return _this.SUBRULE(_this.DirectiveDefinition); } },
            ]);
        });
        _this.TypeSystemExtension = _this.RULE('TypeSystemExtension', function () {
            _this.OR([
                { ALT: function () { return _this.SUBRULE(_this.SchemaExtension); } },
                { ALT: function () { return _this.SUBRULE(_this.TypeExtension); } },
            ]);
        });
        _this.SchemaDefinition = _this.RULE('SchemaDefinition', function () {
            _this.CONSUME(graphQlTokenMap.Schema);
            _this.OPTION(function () {
                return _this.SUBRULE(_this.Directives, { ARGS: [true /* isConst */] });
            });
            _this.CONSUME(graphQlTokenMap.LCurly);
            _this.AT_LEAST_ONE(function () { return _this.SUBRULE(_this.OperationTypeDefinition); });
            _this.CONSUME(graphQlTokenMap.RCurly);
        });
        _this.SchemaExtension = _this.RULE('SchemaExtension', function () {
            _this.CONSUME(graphQlTokenMap.Extend);
            _this.CONSUME(graphQlTokenMap.Schema);
            _this.OR([
                {
                    ALT: function () {
                        _this.SUBRULE(_this.Directives, { ARGS: [true /* isConst */] });
                        _this.OPTION(function () { return _this.SUBRULE1(_this.OperationTypeDefinitionList); });
                    },
                },
                { ALT: function () { return _this.SUBRULE(_this.OperationTypeDefinitionList); } },
            ]);
        });
        _this.OperationTypeDefinitionList = _this.RULE('OperationTypeDefinitionList', function () {
            _this.CONSUME(graphQlTokenMap.LCurly);
            _this.AT_LEAST_ONE(function () { return _this.SUBRULE(_this.OperationTypeDefinition); });
            _this.CONSUME(graphQlTokenMap.RCurly);
        });
        _this.OperationTypeDefinition = _this.RULE('OperationTypeDefinition', function () {
            _this.SUBRULE(_this.OperationType);
            _this.CONSUME(graphQlTokenMap.Colon);
            _this.SUBRULE(_this.NamedType);
        });
        _this.Description = _this.RULE('Description', function () {
            _this.SUBRULE(_this.StringValue);
        });
        _this.TypeDefinition = _this.RULE('TypeDefinition', function () {
            _this.OR([
                { ALT: function () { return _this.SUBRULE(_this.ScalarTypeDefinition); } },
                { ALT: function () { return _this.SUBRULE(_this.ObjectTypeDefinition); } },
                { ALT: function () { return _this.SUBRULE(_this.InterfaceTypeDefinition); } },
                { ALT: function () { return _this.SUBRULE(_this.UnionTypeDefinition); } },
                { ALT: function () { return _this.SUBRULE(_this.EnumTypeDefinition); } },
                { ALT: function () { return _this.SUBRULE(_this.InputObjectTypeDefinition); } },
            ]);
        });
        _this.TypeExtension = _this.RULE('TypeExtension', function () {
            _this.OR([
                { ALT: function () { return _this.SUBRULE(_this.ScalarTypeExtension); } },
                { ALT: function () { return _this.SUBRULE(_this.ObjectTypeExtension); } },
                { ALT: function () { return _this.SUBRULE(_this.InterfaceTypeExtension); } },
                { ALT: function () { return _this.SUBRULE(_this.UnionTypeExtension); } },
                { ALT: function () { return _this.SUBRULE(_this.EnumTypeExtension); } },
                { ALT: function () { return _this.SUBRULE(_this.InputObjectTypeExtension); } },
            ]);
        });
        _this.ScalarTypeDefinition = _this.RULE('ScalarTypeDefinition', function () {
            _this.OPTION(function () { return _this.SUBRULE(_this.Description); });
            _this.CONSUME(graphQlTokenMap.Scalar);
            _this.CONSUME(graphQlTokenMap.Name);
            _this.OPTION1(function () {
                return _this.SUBRULE(_this.Directives, { ARGS: [true /* isConst */] });
            });
        });
        _this.ScalarTypeExtension = _this.RULE('ScalarTypeExtension', function () {
            _this.CONSUME(graphQlTokenMap.Extend);
            _this.CONSUME(graphQlTokenMap.Scalar);
            _this.CONSUME(graphQlTokenMap.Name);
            _this.SUBRULE(_this.Directives, { ARGS: [true /* isConst */] });
        });
        _this.ObjectTypeDefinition = _this.RULE('ObjectTypeDefinition', function () {
            _this.OPTION(function () { return _this.SUBRULE(_this.Description); });
            _this.CONSUME(graphQlTokenMap.TypeToken);
            _this.CONSUME(graphQlTokenMap.Name);
            _this.OPTION1(function () { return _this.SUBRULE(_this.ImplementsInterfaces); });
            _this.OPTION2(function () {
                return _this.SUBRULE1(_this.Directives, { ARGS: [true /* isConst */] });
            });
            _this.OPTION3(function () { return _this.SUBRULE(_this.FieldsDefinition); });
        });
        _this.ObjectTypeExtension = _this.RULE('ObjectTypeExtension', function () {
            _this.CONSUME(graphQlTokenMap.Extend);
            _this.CONSUME(graphQlTokenMap.TypeToken);
            _this.CONSUME(graphQlTokenMap.Name);
            _this.OR([
                {
                    ALT: function () {
                        _this.SUBRULE(_this.ImplementsInterfaces);
                        _this.OPTION(function () {
                            return _this.SUBRULE1(_this.Directives, { ARGS: [true /* isConst */] });
                        });
                        _this.OPTION1(function () { return _this.SUBRULE(_this.FieldsDefinition); });
                    },
                },
                {
                    ALT: function () {
                        _this.SUBRULE(_this.Directives, { ARGS: [true /* isConst */] });
                        _this.OPTION2(function () { return _this.SUBRULE1(_this.FieldsDefinition); });
                    },
                },
                { ALT: function () { return _this.SUBRULE2(_this.FieldsDefinition); } },
            ]);
        });
        _this.ImplementsInterfaces = _this.RULE('ImplementsInterfaces', function () {
            _this.CONSUME(graphQlTokenMap.Implements);
            _this.OPTION(function () { return _this.CONSUME(graphQlTokenMap.Amp); });
            _this.SUBRULE(_this.NamedType);
            _this.MANY(function () {
                _this.CONSUME1(graphQlTokenMap.Amp);
                _this.SUBRULE1(_this.NamedType);
            });
        });
        _this.FieldsDefinition = _this.RULE('FieldsDefinition', function () {
            _this.CONSUME(graphQlTokenMap.LCurly);
            _this.AT_LEAST_ONE(function () { return _this.SUBRULE(_this.FieldDefinition); });
            _this.CONSUME(graphQlTokenMap.RCurly);
        });
        _this.FieldDefinition = _this.RULE('FieldDefinition', function () {
            _this.OPTION(function () { return _this.SUBRULE(_this.Description); });
            _this.CONSUME(graphQlTokenMap.Name);
            _this.OPTION1(function () { return _this.SUBRULE(_this.ArgumentsDefinition); });
            _this.CONSUME(graphQlTokenMap.Colon);
            _this.SUBRULE(_this.Type);
            _this.OPTION2(function () {
                return _this.SUBRULE(_this.Directives, { ARGS: [true /* isConst */] });
            });
        });
        _this.ArgumentsDefinition = _this.RULE('ArgumentsDefinition', function () {
            _this.CONSUME(graphQlTokenMap.LParen);
            _this.AT_LEAST_ONE(function () { return _this.SUBRULE(_this.InputValueDefinition); });
            _this.CONSUME(graphQlTokenMap.RParen);
        });
        _this.InputValueDefinition = _this.RULE('InputValueDefinition', function () {
            _this.OPTION(function () { return _this.SUBRULE(_this.Description); });
            _this.CONSUME(graphQlTokenMap.Name);
            _this.CONSUME(graphQlTokenMap.Colon);
            _this.SUBRULE(_this.Type);
            _this.OPTION1(function () { return _this.SUBRULE(_this.DefaultValue); });
            _this.OPTION2(function () {
                return _this.SUBRULE(_this.Directives, { ARGS: [true /* isConst */] });
            });
        });
        _this.InterfaceTypeDefinition = _this.RULE('InterfaceTypeDefinition', function () {
            _this.OPTION(function () { return _this.SUBRULE(_this.Description); });
            _this.CONSUME(graphQlTokenMap.Interface);
            _this.CONSUME(graphQlTokenMap.Name);
            _this.OPTION2(function () {
                return _this.SUBRULE(_this.Directives, { ARGS: [true /* isConst */] });
            });
            _this.OPTION3(function () { return _this.SUBRULE(_this.FieldsDefinition); });
        });
        _this.InterfaceTypeExtension = _this.RULE('InterfaceTypeExtension', function () {
            _this.CONSUME(graphQlTokenMap.Extend);
            _this.CONSUME(graphQlTokenMap.Interface);
            _this.CONSUME(graphQlTokenMap.Name);
            _this.OR([
                {
                    ALT: function () {
                        _this.SUBRULE(_this.Directives, { ARGS: [true /* isConst */] });
                        _this.OPTION(function () { return _this.SUBRULE(_this.FieldsDefinition); });
                    },
                },
                { ALT: function () { return _this.SUBRULE1(_this.FieldsDefinition); } },
            ]);
        });
        _this.UnionTypeDefinition = _this.RULE('UnionTypeDefinition', function () {
            _this.OPTION(function () { return _this.SUBRULE(_this.Description); });
            _this.CONSUME(graphQlTokenMap.Union);
            _this.CONSUME(graphQlTokenMap.Name);
            _this.OPTION1(function () {
                return _this.SUBRULE(_this.Directives, { ARGS: [true /* isConst */] });
            });
            _this.OPTION2(function () { return _this.SUBRULE(_this.UnionMemberTypes); });
        });
        _this.UnionMemberTypes = _this.RULE('UnionMemberTypes', function () {
            _this.CONSUME(graphQlTokenMap.Equals);
            _this.OPTION(function () { return _this.CONSUME(graphQlTokenMap.Pipe); });
            _this.SUBRULE(_this.NamedType);
            _this.MANY(function () {
                _this.CONSUME1(graphQlTokenMap.Pipe);
                _this.SUBRULE1(_this.NamedType);
            });
        });
        _this.UnionTypeExtension = _this.RULE('UnionTypeExtension', function () {
            _this.CONSUME(graphQlTokenMap.Extend);
            _this.CONSUME(graphQlTokenMap.Union);
            _this.CONSUME(graphQlTokenMap.Name);
            _this.OR([
                {
                    ALT: function () {
                        _this.SUBRULE(_this.Directives, { ARGS: [true /* isConst */] });
                        _this.OPTION(function () { return _this.SUBRULE(_this.UnionMemberTypes); });
                    },
                },
                { ALT: function () { return _this.SUBRULE1(_this.UnionMemberTypes); } },
            ]);
        });
        _this.EnumTypeDefinition = _this.RULE('EnumTypeDefinition', function () {
            _this.OPTION(function () { return _this.SUBRULE(_this.Description); });
            _this.CONSUME(graphQlTokenMap.Enum);
            _this.CONSUME(graphQlTokenMap.Name);
            _this.OPTION1(function () {
                return _this.SUBRULE(_this.Directives, { ARGS: [true /* isConst */] });
            });
            _this.OPTION2(function () { return _this.SUBRULE(_this.EnumValuesDefinition); });
        });
        _this.EnumValuesDefinition = _this.RULE('EnumValuesDefinition', function () {
            _this.CONSUME(graphQlTokenMap.LCurly);
            _this.AT_LEAST_ONE(function () { return _this.SUBRULE(_this.EnumValueDefinition); });
            _this.CONSUME(graphQlTokenMap.RCurly);
        });
        _this.EnumValueDefinition = _this.RULE('EnumValueDefinition', function () {
            _this.OPTION(function () { return _this.SUBRULE(_this.Description); });
            _this.SUBRULE(_this.EnumValue);
            _this.OPTION1(function () {
                return _this.SUBRULE(_this.Directives, { ARGS: [true /* isConst */] });
            });
        });
        _this.EnumTypeExtension = _this.RULE('EnumTypeExtension', function () {
            _this.CONSUME(graphQlTokenMap.Extend);
            _this.CONSUME(graphQlTokenMap.Enum);
            _this.CONSUME(graphQlTokenMap.Name);
            _this.OR([
                {
                    ALT: function () {
                        _this.SUBRULE(_this.Directives, { ARGS: [true /* isConst */] });
                        _this.OPTION(function () { return _this.SUBRULE(_this.EnumValuesDefinition); });
                    },
                },
                { ALT: function () { return _this.SUBRULE1(_this.EnumValuesDefinition); } },
            ]);
        });
        _this.InputObjectTypeDefinition = _this.RULE('InputObjectTypeDefinition', function () {
            _this.OPTION(function () { return _this.SUBRULE(_this.Description); });
            _this.CONSUME(graphQlTokenMap.Input);
            _this.CONSUME(graphQlTokenMap.Name);
            _this.OPTION1(function () {
                return _this.SUBRULE(_this.Directives, { ARGS: [true /* isConst */] });
            });
            _this.OPTION2(function () { return _this.SUBRULE(_this.InputFieldsDefinition); });
        });
        _this.InputFieldsDefinition = _this.RULE('InputFieldsDefinition', function () {
            _this.CONSUME(graphQlTokenMap.LCurly);
            _this.AT_LEAST_ONE(function () { return _this.SUBRULE(_this.InputValueDefinition); });
            _this.CONSUME(graphQlTokenMap.RCurly);
        });
        _this.InputObjectTypeExtension = _this.RULE('InputObjectTypeExtension', function () {
            _this.CONSUME(graphQlTokenMap.Extend);
            _this.CONSUME(graphQlTokenMap.Input);
            _this.CONSUME(graphQlTokenMap.Name);
            _this.OR([
                {
                    ALT: function () {
                        _this.SUBRULE(_this.Directives, { ARGS: [true /* isConst */] });
                        _this.OPTION(function () { return _this.SUBRULE1(_this.InputFieldsDefinition); });
                    },
                },
                { ALT: function () { return _this.SUBRULE(_this.InputFieldsDefinition); } },
            ]);
        });
        _this.DirectiveDefinition = _this.RULE('DirectiveDefinition', function () {
            _this.OPTION(function () { return _this.SUBRULE(_this.Description); });
            _this.CONSUME(graphQlTokenMap.DirectiveToken);
            _this.CONSUME(graphQlTokenMap.At);
            _this.CONSUME(graphQlTokenMap.Name);
            _this.OPTION1(function () { return _this.SUBRULE(_this.ArgumentsDefinition); });
            _this.CONSUME(graphQlTokenMap.On);
            _this.SUBRULE(_this.DirectiveLocations);
        });
        _this.DirectiveLocations = _this.RULE('DirectiveLocations', function () {
            _this.OPTION(function () { return _this.CONSUME(graphQlTokenMap.Pipe); });
            _this.SUBRULE(_this.DirectiveLocation);
            _this.MANY(function () {
                _this.CONSUME1(graphQlTokenMap.Pipe);
                _this.SUBRULE1(_this.DirectiveLocation);
            });
        });
        _this.DirectiveLocation = _this.RULE('DirectiveLocation', function () {
            _this.OR([
                { ALT: function () { return _this.SUBRULE(_this.ExecutableDirectiveLocation); } },
                { ALT: function () { return _this.SUBRULE(_this.TypeSystemDirectiveLocation); } },
            ]);
        });
        _this.ExecutableDirectiveLocation = _this.RULE('ExecutableDirectiveLocation', function () {
            _this.OR([
                { ALT: function () { return _this.CONSUME(graphQlTokenMap.QUERY); } },
                { ALT: function () { return _this.CONSUME(graphQlTokenMap.MUTATION); } },
                { ALT: function () { return _this.CONSUME(graphQlTokenMap.SUBSCRIPTION); } },
                { ALT: function () { return _this.CONSUME(graphQlTokenMap.FIELD); } },
                { ALT: function () { return _this.CONSUME(graphQlTokenMap.FRAGMENT_DEFINITION); } },
                { ALT: function () { return _this.CONSUME(graphQlTokenMap.FRAGMENT_SPREAD); } },
                { ALT: function () { return _this.CONSUME(graphQlTokenMap.INLINE_FRAGMENT); } },
            ]);
        });
        _this.TypeSystemDirectiveLocation = _this.RULE('TypeSystemDirectiveLocation', function () {
            _this.OR([
                { ALT: function () { return _this.CONSUME(graphQlTokenMap.SCHEMA); } },
                { ALT: function () { return _this.CONSUME(graphQlTokenMap.SCALAR); } },
                { ALT: function () { return _this.CONSUME(graphQlTokenMap.OBJECT); } },
                { ALT: function () { return _this.CONSUME(graphQlTokenMap.FIELD_DEFINITION); } },
                { ALT: function () { return _this.CONSUME(graphQlTokenMap.ARGUMENT_DEFINITION); } },
                { ALT: function () { return _this.CONSUME(graphQlTokenMap.INTERFACE); } },
                { ALT: function () { return _this.CONSUME(graphQlTokenMap.UNION); } },
                { ALT: function () { return _this.CONSUME(graphQlTokenMap.ENUM); } },
                { ALT: function () { return _this.CONSUME(graphQlTokenMap.ENUM_VALUE); } },
                { ALT: function () { return _this.CONSUME(graphQlTokenMap.INPUT_OBJECT); } },
                { ALT: function () { return _this.CONSUME(graphQlTokenMap.INPUT_FIELD_DEFINITION); } },
            ]);
        });
        _this.lexer = new Lexer(tokenVocab);
        return _this;
    }
    return BaseGraphQlParser;
}(Parser));
export { BaseGraphQlParser };
